module.exports = __webpack_public_path__ + "static/media/Paw Strip Registered.f476ca78.png";


//////////////////
// WEBPACK FOOTER
// ./src/Paw Strip Registered.png
// module id = 374
// module chunks = 0